import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CheckoutService } from '../checkout.service';
import { CartService } from '../../cart/cart.service';
import { SharedService } from '../../shared.service';

import { ModalService } from '../../modal/modal.service';

import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import * as moment from 'moment';
import { IbanMinLength } from './validators/ibanlength.validator';
import { SiteConfig } from 'app/interfaces/SiteConfig';
import { AppHttpService } from 'app/app-http.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  public addressForm: FormGroup;
  public showCartPage: Boolean =
    this.sharedService.getSiteConfig().showCartPage;
  public pension: Boolean = false;
  public city: string = null;
  public cities: string[] = null;
  public payment: string = null;
  public paymentMethods: string[];
  public hasSepa: boolean = true;
  public bank: string = null;
  public bic: string = null;
  public ibanOrAccount: string = null;
  public streets: string[] = null;
  public apiErrorIban: string = undefined;
  public emailExists: boolean = false;
  public phoneMask = [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ];
  public dateMask = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
  public ibanMask = [
    /[a-zA-Z]/,
    /[a-zA-Z]/,
    /[0-9]/,
    /[0-9]/,
    ' ',
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    ' ',
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    ' ',
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]?/,
    ' ',
    /[a-zA-Z0-9]?/,
    /[a-zA-Z0-9]?/,
    /[a-zA-Z0-9]?/,
    /[a-zA-Z0-9]?/,
    ' ',
    /[a-zA-Z0-9]?/,
    /[a-zA-Z0-9]?/
  ];
  public autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd.mm.yyyy');
  public orderErrorMessages: string[] = [];
  public env: string;
  public invoiceOnly: Boolean = this.sharedService.getSiteConfig().invoice;
  public siteConfig: SiteConfig;
  public jokerType: string = this.sharedService.getSiteConfig().jokerType;
  public wbkz: string = this.checkoutService.getWbkz();
  public hideCouponText = false;
  public limitText: string;

  public showLimit: boolean = false;
  public isLoggedIn: boolean = false;
  public maxMonthlyCosts: number = this.checkoutService.getMaxMonthlyCost();
  public loginUrl: string;
  public showEmailAlert: boolean = false;
  public showLimitError: boolean = false;
  public showSubmitError: boolean = false;
  public savedPaymentMethod: string;

  constructor(
    private checkoutService: CheckoutService,
    private cartService: CartService,
    private sharedService: SharedService,
    private router: Router,
    private modalService: ModalService,
    private api: AppHttpService
  ) {
    this.pension =
      sharedService.getLotterySource() === 'pension' ? true : false;
    this.env = this.sharedService.getEnvironment();
  }

  ngOnInit() {
    const savedData = this.sharedService.getLocalStorage('addressData');
    const prefilled = this.sharedService.getLocalStorage('prefilled');

    this.siteConfig = this.sharedService.getSiteConfig();

    /*
     * Deconstruct object to prefill form with saved
     * data in localStorage
     */
    const {
      salutation,
      firstName,
      lastName,
      zip,
      street,
      streetNumber,
      cities,
      email,
      phoneNumber,
      birthday,
      iban,
      sepaAccept,
      birthName,
      birthplace,
      paymentType
    } = savedData;

    this.city = savedData.cities;
    this.bank = savedData.bank;
    this.bic = savedData.bic;

    this.addressForm = new FormGroup({
      salutation: new FormControl(salutation || prefilled.salutation, [
        Validators.required
      ]),
      firstName: new FormControl(firstName || '', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð][a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.\'-\s]{1,49}$/
        )
      ]),
      lastName: new FormControl(lastName || '', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð][a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.\'-\s]{1,49}$/
        )
      ]),
      zip: new FormControl(zip || '', [
        Validators.required,
        Validators.minLength(4)
      ]),
      street: new FormControl(street || '', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð][a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.\'-\s]{1,49}$/
        )
      ]),
      streetNumber: new FormControl(streetNumber || '', [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern(
          /^\d{1,3}(\s?\D)?(\s?-\s?\d{1,3}(\s?\D)?)?((\s?\/\s)?.*)?$/
        )
      ]),
      country: new FormControl('Deutschland', [
        Validators.required,
        Validators.minLength(2)
      ]),
      cities: new FormControl(cities || ''),
      email: new FormControl(email || '', [
        Validators.required,
        Validators.pattern(this.checkoutService.emailPattern())
      ]),
      phoneNumber: new FormControl(phoneNumber || '', [
        Validators.pattern(/^[0-9+]+[0-9\s\/-]{4,19}$/)
      ]),
      birthday: new FormControl(birthday || '', [
        Validators.required,
        Validators.minLength(2)
      ]),
      birthName: new FormControl(birthName || '', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð][a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.\'-\s]{1,49}$/
        )
      ]),
      birthplace: new FormControl(birthplace || '', [Validators.required]),
      iban: new FormControl(iban || '', {
        // validators: [
        //   Validators.required,
        //   Validators.maxLength(22),
        //   IbanMinLength(22)
        // ]
      }),
      bankCode: new FormControl('', [
        Validators.minLength(12),
        Validators.maxLength(12)
      ]),
      sepaAccept: new FormControl(sepaAccept || false, [
        // Validators.requiredTrue
      ]),
      paymentType: new FormControl(paymentType, [Validators.required])
    });

    /*
     * Write to localStorage on form changes
     */
    this.addressForm.valueChanges.subscribe((data) => {
      data.bank = this.bank;
      data.bic = this.bic;
      data.paymentMethod = this.hasSepa ? 'ibanWithSepa' : 'ibanWithoutSepa';
      this.checkoutService.setAddressData(data);
      this.showSubmitError = false;

      if (!this.addressForm.invalid) {
        this.sharedService.validateStep('step2');
      } else {
        this.sharedService.invalidStep('step2');
      }
    });

    this.addressForm.controls.lastName.valueChanges.subscribe((lastName) => {
      this.addressForm.controls.birthName.patchValue(lastName);
    });

    this.addressForm.controls.paymentType.valueChanges.subscribe((value) => {
      if (value === 'ibanWithSepa') {
        this.addressForm.controls.sepaAccept.setValidators(
          Validators.requiredTrue
        );
        this.addressForm.controls.sepaAccept.updateValueAndValidity();
        this.addressForm.controls.iban.clearValidators();
        this.addressForm.controls.iban.setValidators([
          Validators.required,
          Validators.maxLength(22),
          IbanMinLength(22)
        ]);
        this.addressForm.controls.iban.updateValueAndValidity();
      } else {
        this.addressForm.controls.sepaAccept.clearValidators();
        this.addressForm.controls.sepaAccept.updateValueAndValidity();
        this.addressForm.controls.bankCode.setErrors({ required: false });
        this.addressForm.controls.bankCode.setErrors({ minLength: false });
        this.addressForm.controls.bankCode.setErrors({ incorrect: false });
        this.addressForm.controls.bankCode.clearValidators();
        this.addressForm.controls.iban.clearValidators();
        this.addressForm.controls.bankCode.updateValueAndValidity();
        this.addressForm.controls.iban.updateValueAndValidity();
      }
    });

    /*
     * If going back to step1 and again to step2,
     * this.streets needs to be refilled with the saved streets
     * for this city.
     */
    if (this.checkoutService.getAllStreets()) {
      this.streets = this.checkoutService.getStreets(this.city);
    }

    /*
     * If user reloads page, remote zip, email & phone validation
     * need to be done to get the streets for the
     * city.
     * Only if zip is already filled out and saved in
     * local storage
     */
    if (zip) {
      this.addressForm.controls.zip.markAsTouched();
      this.validateZip(zip);
    }

    if (email) {
      this.addressForm.controls.email.markAsTouched();
      this.validateEmail(email);
    }

    if (phoneNumber) {
      this.addressForm.controls.phoneNumber.markAsTouched();
      this.validatePhone(phoneNumber);
    }

    /*
     * If it is not landing page, track via GTM.
     */
    if (this.showCartPage) {
      this.sharedService.pushToDataLayer(
        { step: 2 },
        this.cartService.getProducts()
      );
    }

    // For landing pages only get the payment methods for this landing page
    // and depending on the methods, show the sepa checkbox or not.
    if (!this.showCartPage) {
      const landingPageId = this.sharedService.getSiteConfig().landingPageId;

      this.api.getPaymentMethods(landingPageId).subscribe((response) => {
        this.paymentMethods = response['paymentMethods'];

        if (this.paymentMethods.includes('ibanWithSepa')) {
          this.hasSepa = true;
          this.addressForm.controls.sepaAccept.setValidators(
            Validators.requiredTrue
          );
          this.addressForm.controls.sepaAccept.updateValueAndValidity();
        } else {
          this.hasSepa = false;
          this.addressForm.controls.sepaAccept.clearValidators();
          this.addressForm.controls.sepaAccept.updateValueAndValidity();
        }
      });
    }

    /*
     * Make iban & bankcode non-mandatory if invoice is accepted
     */
    if (this.invoiceOnly) {
      this.addressForm.controls.bankCode.clearValidators();
      this.addressForm.controls.iban.clearValidators();
      this.addressForm.controls.sepaAccept.clearValidators();
    }

    /**
     * Hide the coupon text when wbkz value contains 'PA':
     * See GDE-327 for further information.
     */
    if (this.wbkz && this.wbkz.includes('PA')) {
      this.hideCouponText = true;
    }

    this.checkoutService.getMe().subscribe(
      (response) => {
        this.isLoggedIn = true;
        this.sharedService.setLoggedIn(true);
        if (response && response.person) {
          this.addressForm.patchValue({
            ...response.person,
            cities: response.person.city,
            birthday: moment(response.person.birthDate).format('DD.MM.YYYY'),
            paymentType:
              response.person.paymentMethod === 'paypal'
                ? 'paypal'
                : 'ibanWithSepa'
          });
          this.maxMonthlyCosts = response.person.maxMonthlyCosts;
          this.city = response.person.city;
          this.savedPaymentMethod = response.person.paymentMethod;

          if (response.person.paymentMethod === 'ibanWithSepa') {
            this.hasSepa = true;
            this.addressForm.controls.sepaAccept.clearValidators();
            this.addressForm.controls.sepaAccept.updateValueAndValidity();
          }
        }
      },
      (error) => {
        this.isLoggedIn = false;
        this.sharedService.setLoggedIn(false);
      }
    );
  }

  checkIfSingleCity(value) {
    return typeof value === 'string';
  }

  validateZip(value) {
    if (value.length < 4) {
      return;
    }
    this.checkoutService.validate('zip', value).subscribe(
      (response) => {
        const cityData = this.checkoutService.cityHelper(response);
        this.checkoutService.setStreets(response);
        this.renderCity(cityData);
        this.addressForm.controls.zip.setErrors(null);
      },
      (error) => {
        this.city = null;
        this.cities = null;
        this.addressForm.controls.zip.setErrors({ noZip: true });
      }
    );
  }

  validateEmail(value) {
    if (value.length === 0) {
      return;
    }
    this.checkoutService.validate('email', value).subscribe(
      () => {},
      (error) => {
        this.addressForm.controls.email.setErrors({ notReal: true });
      }
    );
  }

  validatePhone(value) {
    if (value.length === 0) {
      return;
    }
    this.checkoutService.validatePhone(value.trim()).subscribe(
      (response) => {
        this.addressForm.controls.phoneNumber.setValue(response);
      },
      (error) => {
        this.addressForm.controls.phoneNumber.setErrors({
          notReal: true
        });
      }
    );
  }

  validateAge(value) {
    const age = moment(value, 'DD.MM.YYYY');
    const now = moment();
    if (now.diff(age, 'years') < 18) {
      this.addressForm.controls.birthday.setErrors({ tooYoung: true });
    }

    if (now.diff(age, 'years') > 120) {
      this.addressForm.controls.birthday.setErrors({ tooOld: true });
    }
  }

  validateIban(value) {
    if (
      this.payment !== 'iban' ||
      value.length < 21 ||
      value.substr(value.length - 1) === '_'
    ) {
      return;
    }
    const iban = this.checkoutService.removeSpaces(value);
    this.checkoutService.validate('iban', iban).subscribe(
      (response) => {
        this.bank = response.bankname;
        this.bic = response.bic;
        this.addressForm.controls.iban.setValue(response.iban);
      },
      (error) => {
        this.bank = null;
        this.bic = null;
        this.addressForm.controls.iban.setErrors({ apiError: true });
        this.apiErrorIban = error.error.msgs[0];
      }
    );
  }

  validateBankAccount(value) {
    if (value.length !== 8) {
      return;
    }
    this.checkoutService
      .validateBankAccount(this.ibanOrAccount, value)
      .subscribe(
        (response) => {
          this.bank = response.bankname;
          this.bic = response.bic;
          this.addressForm.controls.iban.setValue(response.iban);
          this.payment = 'iban';
        },
        (error) => {
          this.bank = null;
          this.bic = null;
          this.addressForm.controls.bankCode.setErrors({
            notReal: true
          });
        }
      );
  }

  /**
   *
   * @param formGroup
   *
   * Is invoked when the form is submitted but the form data is not
   * valid yet.
   * Loops through all the form fields and displays their error messages
   * if field is invalid.
   * This is achieved by setting each field to "touched" state.
   */
  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  trimStreetNumber(value) {
    this.addressForm.controls.streetNumber.setValue(value.trim());
  }

  checkExistingEmail(value) {
    this.checkoutService.checkExistingEmail(value).subscribe(
      (response) => {
        this.showEmailAlert = true;
        this.emailExists = response.found;
        this.loginUrl = `/meinkonto/login/?order=true&redirect=${encodeURIComponent(
          window.location.href
        )}&email=${encodeURIComponent(value)}`;
      },
      (error) => {
        this.showEmailAlert = true;
        this.emailExists = false;
        this.loginUrl = `/meinkonto/login/?order=true&redirect=${encodeURIComponent(
          window.location.href
        )}`;
      }
    );
  }

  getIbanMask = (value) => {
    if (this.payment === 'iban') {
      return this.ibanMask;
    } else {
      return false;
    }
  };

  paymentType(value) {
    this.ibanOrAccount = value;

    if (!isNaN(value.substr(0, 2)) && value.length > 0) {
      this.payment = 'account';
      this.addressForm.controls.bankCode.clearValidators();
      this.addressForm.controls.iban.clearValidators();
      this.addressForm.controls.bankCode.setValidators([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8)
      ]);
      this.addressForm.controls.iban.setValidators([
        Validators.required,
        Validators.minLength(4)
      ]);
    } else {
      this.payment = 'iban';
      this.addressForm.controls.bankCode.setValue('');
      this.addressForm.controls.bankCode.setErrors({ required: false });
      this.addressForm.controls.bankCode.setErrors({ minLength: false });
      this.addressForm.controls.bankCode.setErrors({ incorrect: false });
      this.addressForm.controls.bankCode.clearValidators();
      this.addressForm.controls.iban.clearValidators();
      this.addressForm.controls.iban.setValidators([
        Validators.required,
        IbanMinLength(22)
      ]);
      this.addressForm.controls.bankCode.updateValueAndValidity();
    }

    if (value === '') {
      this.payment = null;
    }
  }

  renderCity(data) {
    if (this.checkIfSingleCity(data)) {
      this.streets = this.checkoutService.getStreets(data);
      this.addressForm.controls.cities.setValue(data);
      this.city = data;
    } else {
      this.streets = this.checkoutService.getStreets(data[0]);
      this.addressForm.controls.cities.setValue(data[0]);
      this.city = null;
      this.cities = data;
    }
  }

  /*
   * @param {String} type
   *
   * Used to open the legal text modals beneath the form.
   * The passed type decided which content to load.
   */
  openModal(type: string): boolean {
    this.modalService.openModal(type);

    return false;
  }

  /*
   * @param {Object} data
   *
   * If user enters a zip with multiple possible cities, the address form
   * shows a select dropdown to select to correct city.
   * The method is called on selecting the city
   */
  onCitySelect(data: object) {
    if (data) {
      this.streets = this.checkoutService.getStreets(data);
    }
  }

  onStreetSelect(street: string, nextElement: HTMLElement) {
    if (!this.addressForm.controls.streetNumber.valid) {
      nextElement.focus();
    }
  }

  /*
   * Since the address component can be loaded on the normal cart/checkout
   * process and on the landing page, where you submit the order on the same step,
   * we have to check if we're on landing page or on standard checkout.
   */
  onSubmit() {
    if (this.addressForm.invalid) {
      this.validateAllFormFields(this.addressForm);
      this.showSubmitError = true;
      return;
    }

    if (!this.showCartPage) {
      const orderData = this.checkoutService.getOrderData();
      const backPay = this.cartService.getBackPay();
      const serviceFee = this.cartService.getServiceFee();

      const lottery = this.cartService.getLottery();
      const startDate = moment(lottery.start);
      const lotteryNumber = this.cartService.getLotteryNumber();
      const lotteryStartDate = startDate.format('DD.MM.YYYY');

      if (orderData.totalFee - serviceFee + backPay > 150 && !this.isLoggedIn) {
        this.limitText = `Die ${lotteryNumber}. Lotterie hat bereits am ${lotteryStartDate} begonnen. Sie haben noch die Möglichkeit in die laufende Lotterie einzusteigen. Für bereits abgelaufene Klassen müssen Sie Ihren Einsatz nachentrichten. Dies gilt nicht für die Joker Spiele.`;
        this.showLimitError = true;
        return;
      }
    }

    this.sharedService.validateStep('step2');
    this.router.navigate(['/bestellen/bestaetigung']);
  }

  toggleLimit() {
    this.showLimit = !this.showLimit;

    return false;
  }

  onLimitFormChange(form: FormGroup) {
    form.valueChanges.subscribe((value) => {
      this.maxMonthlyCosts = value.limit;

      if (form.invalid) {
        this.addressForm.setErrors({ invalid: true });
      } else {
        this.addressForm.setErrors(null);
      }
    });
  }

  displayLandingPageCouponField() {
    const couponField = <HTMLInputElement>(
      document.getElementById('couponWrapper')
    );
    const couponClear = <HTMLElement>document.getElementById('couponClear');

    couponField.style.display = 'block';
    couponClear.style.display = 'block';
  }

  capitalizeFirstLetter(value, targetName) {
    this.addressForm.controls[targetName].setValue(
      value.charAt(0).toUpperCase() + value.slice(1)
    );
  }
}
